import { z } from "zod";
import { VENUS_QWEN38_MODAL_MODEL, VENUS_QWEN38_VERDA_MODEL, } from "./self-hosted-experiment.js";
export const venusServingProfileSchema = z.object({
    servedModel: z.string().min(1).max(512),
    modelId: z.string().min(1).max(512),
    quantization: z.string().min(1).max(64),
    engine: z.string().min(1).max(128),
});
// These are artifact identities, not admission routes. The GGUF endpoint reports
// a content hash; resolve only the exact pinned artifact, never by GPU name.
export function parseVenusServingProfile(value) {
    const base = z
        .object({
        servedModel: z.literal(VENUS_QWEN38_MODAL_MODEL),
        engine: z.string().min(1).max(128),
    })
        .parse(value);
    if (base.engine.startsWith("llama.cpp:")) {
        z.object({
            modelSha256: z.literal("8601193d3d5760c37fb8ce1b43afebc69df5fb24e1fbc5a547c32e2200305276"),
        }).parse(value);
        return {
            ...base,
            modelId: VENUS_QWEN38_VERDA_MODEL,
            quantization: "GGUF · Q5_K_XL",
        };
    }
    const a100 = z
        .object({
        target: z.literal("dbirks/Qwen3.8-27B-W4A16-AutoRound"),
        revision: z.string().regex(/^[a-f0-9]{40}$/),
        engine: z.literal("vllm:0.27.1"),
    })
        .parse(value);
    return {
        ...base,
        modelId: `${a100.target}@${a100.revision}`,
        quantization: "W4A16 · 4-bit weights / 16-bit activations",
    };
}
